import React, { Component } from "react";
import DeviceDetector from "device-detector-js";

// Components
import Navbar from "../components/navbar/navbar";
import NavbarMobile from "../components/navbar/navbarMobile";
import LandingComponent from "../components/landing/landing";

class GetApp1 extends Component {
    componentDidMount() {
        const deviceDetector = new DeviceDetector();
        const userAgent = navigator.userAgent;
        const device = deviceDetector.parse(userAgent);
        const deviceOS = device.os.name;

        if (deviceOS === "Windows" || deviceOS === "Mac") {
            return;
        } else {
            if (deviceOS === "iOS") {
                window.location.href =
                    "https://apps.apple.com/us/app/money-jar/id1469836079";
            } else {
                window.location.href =
                    "https://play.google.com/store/apps/details?id=com.mymoneyjar.mobile&hl=en_IE&gl=IE";
            }
        }
    }

    render() {
        return (
            <div
                className="container"
                style={{ justifyContent: "space-evenly" }}
            >
                <Navbar />
                <NavbarMobile />
                <LandingComponent />
            </div>
        );
    }
}

export default GetApp1;
